import { CommonNoticeIcon } from '@local/assets/icons'

import { gql } from '@web/gql'
import { ReviewTab_ReviewGroupCard_Place_ReviewGroupFragment } from '@web/gql/graphql'
import { messages } from '@web/libs/constants'

import styles from './ReviewGroupCard.module.scss'

const Place = ({ reviewGroup }: { reviewGroup: ReviewTab_ReviewGroupCard_Place_ReviewGroupFragment }) => {
  const { place, visit } = reviewGroup
  const name = place?.name ?? visit?.displayName ?? messages.NONE_PLACE_ADDRESS

  const isValidPlace = !!place?.isAvailable
  const isBusiness = !!visit?.business

  const locationText = place?.locationText

  return (
    <div className={styles.info_area}>
      {isValidPlace && !!locationText && <div className={styles.location}>{locationText}</div>}
      <div className={styles.place_name}>
        <span className={styles.name}>{name}</span>
        {!isValidPlace && !isBusiness && <CommonNoticeIcon className={styles.icon} aria-hidden="true" />}
      </div>
    </div>
  )
}

export default Place

Place.fragments = {
  reviewGroup: gql(`
    fragment ReviewTab_ReviewGroupCard_Place_ReviewGroup on ReviewGroup {
      place {
        id
        name
        isAvailable
        locationText
      }
      visit {
        id
        displayName
        visitedDateTime
        business {
          id
        }
      }
    }
  `),
}
